import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { MembersProvider } from 'pages/settings/pages/members/context/membersContext'

export const MembersLayout = observer(() => {
  return (
    <MembersProvider>
      <Outlet />
    </MembersProvider>
  )
})
